import type {
  DeleteSnapQuotePriceInput,
  DeleteSnapQuotePriceOutput,
} from '@snap-types/actions/delete-snap-quote-price';
import { QUOTE_BUILDER_SLICE_NAME } from '@ui/constants/quote-builder';
import { buildSnapQuoteUrl } from '@ui/store/api-builder/build-url';
import { injectMutation } from '@ui/store/api-builder/inject-mutation';

const [deleteSnapQuotePrice, _] = injectMutation<
  DeleteSnapQuotePriceInput,
  DeleteSnapQuotePriceOutput
>(
  `${QUOTE_BUILDER_SLICE_NAME}/deleteSnapQuotePrice`,
  ({ siteCode, quoteUuid, quoteLineUuid, quotePriceUuid }) => ({
    url: buildSnapQuoteUrl(
      siteCode,
      quoteUuid,
      `quote-lines/${quoteLineUuid}/quote-prices/${quotePriceUuid}`,
    ),
    method: 'DELETE',
  }),
);

export { deleteSnapQuotePrice };
